import React, { useState, useEffect } from "react";
import * as b from "./bootstrap.module.css";
import { graphql, Link, useStaticQuery } from "gatsby";
import ThemeToggle from './theme-toggle';
import resolveUrl from '../utils/urls/resolve-url';

import NonBankLoanNavigation from './top-navigation/non-bank-loan-navigation';
import CreditNavigation from './top-navigation/credit-navigation';
import LocalfirmsNavigation from './top-navigation/localfirms-navigation';
import AccountNavigation from './top-navigation/account-navigation';

const Header = () => {
  const { categories } = useStaticQuery(graphql`
    query Header {
      categories: allMysqlTerms(filter: {menu: {glob: "*header*"}, cluster: {ne: "menu"}, menu_parent: {eq: 0}}, sort: {fields: sort, order: ASC}) {
        nodes {
          term
          term_normalized
          path
          cluster
        }
      }
    }
  `);

  const [activeNavigation, setActiveNavigation] = useState('');
  const [activeMobileNavigation, setActiveMobileNavigation] = useState(false);

  const offAll = () => {
    setActiveNavigation('');
    setActiveMobileNavigation(false);
  };
  const forceOffAll = (e) => {
    if (e.target.nodeName === 'A' || e.target.closest('a')) {
      offAll();
    }
  };
  const toggler = () => setActiveMobileNavigation(!activeMobileNavigation);
  const changeNavigation = (cluster) => setActiveNavigation(activeNavigation !== cluster ? cluster :  '');

  useEffect(() => {
    document.body.classList.toggle('blur', activeNavigation);
  }, [activeNavigation]);

  useEffect(() => {
    if (!activeMobileNavigation) {
      offAll();
    }
  }, [activeMobileNavigation]);

  return (
    <header 
      onClickCapture={forceOffAll} 
      className={`header ${activeNavigation || activeMobileNavigation ? 'open' : ''} ${activeNavigation ? 'active-navigation' : ''}`}
    >
      <div className={b.container}>
        <div className={`${b.row} ${b.alignItemsCenter}`}>
          <div className={`${b.col} ${b.colLgAuto}`}>
            <Link onClick={offAll} to="/" className="header-logo" aria-label="Akredo.pl">
              <svg width="94" height="35" viewBox="0 0 94 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_9927_167983)">
                  <path d="M83.9056 12.5482C79.5834 12.5482 76.0681 16.0127 76.0681 20.2726C76.0681 24.5324 79.5834 28 83.9056 28C88.2278 28 91.7462 24.5324 91.7462 20.2726C91.7462 16.0127 88.2278 12.5482 83.9056 12.5482ZM83.9056 24.7244C81.3488 24.7244 79.2742 22.7316 79.2742 20.2726C79.2742 17.8136 81.3488 15.8208 83.9056 15.8208C86.4624 15.8208 88.5401 17.8136 88.5401 20.2726C88.5401 22.7316 86.4655 24.7244 83.9056 24.7244Z" fill="#2B272F"/>
                  <path d="M83.9047 23.2163L81.2463 20.5963C80.6866 20.0447 80.6888 19.1505 81.2463 18.6011C81.806 18.0495 82.7132 18.0517 83.2707 18.6011L84.9169 20.2235C85.4765 20.7751 85.4743 21.6693 84.9169 22.2187L83.9047 23.2163Z" fill="#58A996"/>
                  <path d="M7.52829 27.6648C3.3885 27.6648 0 24.3252 0 20.2421C0 16.159 3.3885 12.8224 7.52829 12.8224C11.6681 12.8224 15.0597 16.162 15.0597 20.2451V27.4089H12.1627V25.9524C10.9477 26.8665 9.29674 27.6648 7.52829 27.6648ZM12.1627 20.2451C12.1627 17.7343 10.0789 15.6776 7.52829 15.6776C4.97763 15.6776 2.89383 17.7313 2.89383 20.2451C2.89383 22.759 4.97763 24.8127 7.52829 24.8127C10.0789 24.8127 12.1627 22.759 12.1627 20.2451Z" fill="#2B272F"/>
                  <path d="M26.0352 20.1294L31.4519 25.4679L29.3959 27.4942L23.9236 22.1008L20.5629 25.2393V27.4089H17.666V6H20.5629V21.2994L29.3959 13.051L31.4519 15.0773L26.0352 20.1294Z" fill="#2B272F"/>
                  <path d="M36.952 13.1363V14.2789C38.167 13.3953 39.6758 12.8529 41.2958 12.8529V15.708C38.8936 15.708 36.952 17.6216 36.952 19.9892V27.4119H34.0551V13.1363H36.952Z" fill="#2B272F"/>
                  <path d="M49.4053 24.8371C50.6513 24.8371 51.7798 24.2094 52.5898 23.4111L54.7323 25.5227C53.3411 26.8634 51.4891 27.6923 49.4022 27.6923C45.2315 27.6923 41.874 24.3801 41.874 20.2726C41.874 16.1651 45.2346 12.8499 49.4022 12.8499C53.5699 12.8499 56.9336 15.9884 56.9336 21.7565H45.0893C45.6984 23.469 47.4359 24.8402 49.4053 24.8402V24.8371ZM49.4053 15.7019C47.3772 15.7019 45.6397 17.1859 45.0615 18.8983H53.7213C53.171 17.1859 51.4335 15.7019 49.4053 15.7019Z" fill="#2B272F"/>
                  <path d="M70.8339 14.4191V6H73.7308V27.4058H70.8339V26.123C69.5601 27.1224 67.937 27.6922 66.1994 27.6922C62.0287 27.6922 58.6712 24.3801 58.6712 20.2726C58.6712 16.1651 62.0318 12.8499 66.1994 12.8499C67.937 12.8499 69.5601 13.4197 70.8339 14.4191ZM70.8339 20.2695C70.8339 17.8136 68.7779 15.8177 66.1994 15.8177C63.621 15.8177 61.565 17.8166 61.565 20.2695C61.565 22.7224 63.621 24.7213 66.1994 24.7213C68.7779 24.7213 70.8339 22.7224 70.8339 20.2695Z" fill="#2B272F"/>
                  <path d="M81.8802 21.2202L91.5562 11.6839C92.1158 11.1323 93.0231 11.1344 93.5806 11.6839C94.1402 12.2355 94.138 13.1296 93.5806 13.6791L84.9168 22.2178C84.3572 22.7694 83.4499 22.7672 82.8924 22.2178L81.8802 21.2202Z" fill="#58A996"/>
                </g>
                <defs>
                  <clipPath id="clip0_9927_167983">
                    <rect width="94" height="22" fill="white" transform="translate(0 6)"/>
                  </clipPath>
                </defs>
              </svg>
            </Link>
          </div>
          
          <ThemeToggle />

          <div className={`top-navigation-list-wrapper ${b.colAuto} ${b.colLg} ${b.dNone} ${b.dLgFlex} ${b.justifyContentEnd} ${b.px0}`}>
            <div className={`${b.container} ${b.prLg0}`}>
              <ul className="top-navigation-list blackToWhite">
                {categories.nodes.map((category, i) => (
                  <li key={i}>
                    <button 
                      onClick={() => changeNavigation(category.cluster)}
                      className={category.cluster === activeNavigation ? 'active' : ''}
                    >{category.term}</button>
                  </li>
                ))}

                <li>
                  <button 
                    to={resolveUrl('posrednicy-kredytowi')} 
                    onClick={() => changeNavigation('localfirms_5')}
                    className={'localfirms_5' === activeNavigation ? 'active' : ''}
                  >Pośrednicy kredytowi</button>
                </li>
              </ul>
            </div>
          </div>

          <div className={`${b.colAuto} ${b.pl0} ${b.dLgNone} cursor-pointer`}>
            <button onClick={toggler} className={["header-toggle","header-btn", b.ml3].join(' ')} aria-label='menu'>
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </div>

      <nav className="top-navigation">
        <div id="top-navigation-scroll" className={b.container}>
          <NonBankLoanNavigation activeNavigation={activeNavigation} changeNavigation={changeNavigation} />
          <CreditNavigation activeNavigation={activeNavigation} changeNavigation={changeNavigation} />
          <AccountNavigation activeNavigation={activeNavigation} changeNavigation={changeNavigation} />
          <LocalfirmsNavigation activeNavigation={activeNavigation} changeNavigation={changeNavigation} />
        </div>
      </nav>

      <button className="header-hidden-btn" onClick={offAll} aria-label="Zamknij całą górną nawigację">&nbsp;</button>
    </header>
  );
};

export default Header
